<template>
  <div class="layout">
    <div class="layout-header d-flex align-items-center border-bottom">
      <div class="brand d-flex justify-content-between align-items-center w-25 border-right p-3 h-100">
        <slot name="brand">
          <img :alt="$t('title')" src="/static/img/logo_short.png">
          <template v-if="!$helper.isLegacy">
            <img :alt="get().parameters ? get().parameters.company.name :''" :src="$helper.getImage(get().parameters.logo)">
          </template>
          <div v-if="user()" class="user text-center text-secondary">
            <i class="ti ti-fw ti-2x ti-user-circle" /><br>
            <small class="text-uppercase font-weight-bold">
              {{ _.first(user().first_name) }}.{{ user().last_name }}
            </small>
          </div>
        </slot>
      </div>
      <div class="title-header w-50 border-right d-flex align-items-center justify-content-center h-100 flex-column">
        <slot name="title">
          <h1>{{ title }}</h1>
          <h2 v-if="subTitle && !$helper.isPlayerDemo12">
            {{ subTitle }}
          </h2>
        </slot>
      </div>
      <slot name="right-column" />
    </div>
    <div class="layout-container">
      <slot name="container" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LayoutView',
    props: {
      title: {
        type: String,
        default: null,
      },
      subTitle: {
        type: String,
        default: null,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .layout-header {
    height: $nav-height;
    position: fixed;
    width: 100%;
    background-color: $white;
    z-index: 1;

    .brand {
      img {
        max-height: 55px;
        max-width: 90px;
      }
    }

    .title-header {
      padding: 0.5rem 1rem;

      h2 {
        margin-top: 0.5rem;
        text-align: center;
        font-size: 1rem;
      }
    }
  }

  .layout-container {
    padding-top: $nav-height;
  }
</style>
